import { InputBaseComponentProps, TextField } from "@mui/material"
import { InputHTMLAttributes } from "react"
import { UseFormRegister, UseFormSetValue } from "react-hook-form"
import { twMerge } from "tailwind-merge"
import InputMask from 'react-input-mask'
import { CurrencyInput } from 'react-currency-mask'

interface ControlledProps extends InputHTMLAttributes<HTMLInputElement> {
    // register: UseFormRegister<any>
    register: any
    name: string
    currency?: boolean
    setValue?: UseFormSetValue<any>
    inputProps?: InputBaseComponentProps
    value?: string
}

export function Controlled({ register, name, inputProps: props, currency = false, value, setValue, ...rest }: ControlledProps) {
    return currency ? (
        <CurrencyInput
            onChangeValue={(event, originalValue, maskedValue) => {
                if (setValue) {
                    setValue(name, originalValue)
                }
            }}
            {...register(name)}
            InputElement={
                <TextField id="outlined-basic" variant="outlined"
                    size="small"
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderRadius: '12px',
                        },
                    }}
                    inputProps={props}
                    className={twMerge("tw-px-4 tw-py-1 tw-h-[34px] tw-text-justify tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-zinc-400 max-md:tw-pr-5 max-md:tw-mt-10 max-md:tw-max-w-full", rest.className)}

                />
            }
            {...rest}
        />
    ) : (
        <TextField id="outlined-basic" variant="outlined"
            size="small"
            sx={{
                '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderRadius: '12px',
                },
            }}
            inputProps={props}
            {...register(name)}
            className={twMerge("tw-px-4 tw-py-1 tw-h-[34px] tw-text-justify tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-zinc-400 max-md:tw-pr-5 max-md:tw-mt-10 max-md:tw-max-w-full", rest.className)}
            {...rest}
        />
    )
}